import Component from '../../js/_Component';

const CNAME = 'c-base-form-select';

export default class BaseFormSelect extends Component {
	constructor(element: HTMLElement) {
		super(element);

		// This is to allow for a fake "placeholder" value to be styled.
		let thisSelect = element.querySelector('select') as HTMLSelectElement;
		thisSelect.addEventListener("change",() => {
			 thisSelect.setAttribute("data-select",thisSelect.options[thisSelect.selectedIndex].value);
		});
	}
}

Component.register(BaseFormSelect, 'BaseFormSelect');
